// extracted by mini-css-extract-plugin
module.exports = {"container":"EventFeedbackPage_container__3WWL2","content":"EventFeedbackPage_content__2-8bE"};